import { IsUUID, IsOptional, IsNotEmpty } from 'class-validator'
import { ApiProperty } from '@nestjs/swagger'

export class CreateProgramConceptPrerequisiteDto {
  @ApiProperty({ description: 'Source program concept UUID (prerequisite)' })
  @IsUUID()
  @IsNotEmpty()
  sourceProgramConceptId!: string

  @ApiProperty({
    description: 'Target program concept UUID (depends on source)',
  })
  @IsUUID()
  @IsNotEmpty()
  targetProgramConceptId!: string
}
